import React from "react";
import styles from "./ScrollLoder.module.css";
function ScrollLoder() {
  return (
    <div>
      <div className={styles.loader}>
        <span className={styles.bar}></span>
        <span className={styles.bar}></span>
        <span className={styles.bar}></span>
      </div>
    </div>
  );
}

export default ScrollLoder;
